import type { ChangelogEntry } from "../types";

/** Nytt signalkort med logo, fire handlinger og sveip ved avvisning, og samtaleutfall. */
export const SIGNALKORT_V2_2026_10: ChangelogEntry = {
  id: "2026-10-27-signalkort-v2",
  date: "2026-10-27",
  title: "Nytt signalkort: e-post, ring, følg opp senere eller avvis",
  summary:
    "Signalkortet viser kunden med logo og selve signalet øverst, og har fire knapper. Avvis sveiper kortet ut til venstre. Etter en samtale velger du hva som ble avtalt.",
  sections: [
    {
      heading: "Salgsmuligheter",
      minRole: "user",
      items: [
        {
          title: "Signalkortet er tydeligere",
          kind: "forbedret",
          featureFlag: "feature_crm_signaler",
          body: "Kortet viser kunden med logo, signalet med sitat og lenke til kilden, hvorfor Sølvrev bør ta kontakt, og kontakt, tidligere verdi og siste kontakt. Øverst ser du hvor i køen du er.",
        },
        {
          title: "E-post, Ring, Følg opp senere og Avvis",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "E-post åpner utkastet, Ring åpner samtalen med nummeret, og Følg opp senere lar deg velge dato. Alle tre gjør signalet til ditt. Avvis (eller pil venstre, eller dra kortet til venstre) sveiper kortet ut med et rødt «AVVIS».",
        },
        {
          title: "Samtalen ender med det som ble avtalt",
          kind: "nytt",
          featureFlag: "feature_crm_ko_pipe",
          body: "Etter en samtale velger du Booket møte, Følg opp på e-post, Ring igjen, Fikk ikke svar eller Ikke aktuelt nå, og neste handling åpnes med en gang. Det gjelder også «Tok det på tlf» på vanlige oppfølginger.",
        },
        {
          title: "Kontakt uten navn vises som e-post",
          kind: "rettet",
          featureFlag: "feature_crm_ko_pipe",
          body: "Kunder der PowerOffice bare har e-post eller telefon, viste kontaktpersonen «Kontaktperson». Nå står e-posten eller telefonnummeret, merket «uten navn».",
        },
      ],
    },
  ],
};
